import styled, { css } from 'styled-components';

/* v2: lay the two form sections (personal data | contact person) side by side
   to fill the card width; v1 keeps the classic stacked flow. */
export const DataGrid = styled.div`
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 24px 72px;
      align-items: start;
      @media (max-width: 1200px) {
        grid-template-columns: minmax(0, 1fr);
        gap: 24px;
      }
      & > * {
        min-width: 0;
      }
      /* clear visual separation between the two forms */
      & > *:first-child {
        padding-right: 8px;
      }
      & > *:last-child {
        padding-left: 8px;
        border-left: 1px solid var(--cp-border);
        padding-left: 40px;
      }
      @media (max-width: 1200px) {
        & > *:last-child {
          border-left: 0;
          padding-left: 8px;
          border-top: 1px solid var(--cp-border);
          padding-top: 24px;
        }
      }
    `}
`;

export const ClientInfo = styled.div`
  margin: 0 0 1rem;
  width: 590px;
  position: relative;
  form > div:last-child {
    margin-top: 20px;
  }
`;

export const Contacts = styled.div`
  position: relative;
`;